import { RocketIntegrationError } from './RocketIntegrationError';

export class RocketRequestTimeoutError extends RocketIntegrationError {
  static errorName = 'RocketRequestTimeoutError';

  public request?: object;

  constructor(message: string, request?: object) {
    super(message);
    if (request) this.request = request;
  }
}
